export default __webpack_public_path__ + "static/media/img_9.508d4c4c.jpg";